import { Feature } from "ol";
import { Point } from "ol/geom";
import { fromLonLat } from "ol/proj";
import { Circle, Fill, Stroke, Style, Text } from "ol/style";
import { defaultStyles } from "../DefaultStyles";
import { CarLocation } from "@/components/Passenger/models/RouteWithTrips";

export default class CarFeature extends Feature {
  name: string;
  constructor(location: CarLocation, carName?: string) {
    super({ geometry: new Point(fromLonLat([location.longitude, location.latitude])) });
    this.name = carName;
    this.setStyle(this.getDefaultStyle());
  }

  updateLocation(location: CarLocation) {
    this.setGeometry(new Point(fromLonLat([location.longitude, location.latitude])));
  }

  private getDefaultStyle() {
    return new Style({
      image: new Circle({
        radius: 15,
        fill: new Fill({ color: defaultStyles.colors.selected }),
        stroke: new Stroke({
          color: defaultStyles.colors.dark,
          width: 1,
        }),
      }),
      text: new Text({
        text: this.name,
        font: defaultStyles.font,
        fill: new Fill({ color: defaultStyles.colors.light }),
        stroke: new Stroke({ color: defaultStyles.colors.dark, width: defaultStyles.strokeWidth }),
      }),
      zIndex: 10,
    });
  }
}